import axios from 'axios';

const URL = process.env.REACT_APP_BACKEND_URL.replace(/v1/g, '');

export const getStatus = () => {
  return axios.get(URL);
}